import { backend } from './setup';
import { scanner } from "ln/view/Scanner";
import { Node } from "ln/node/Node";
import setup from 'ln/setup/setup';
import Lang from 'ln/lang/Lang';

// views
import './library/Library';
import './course/Editor';
import './general/DayPicker';
import './general/HeaderScrollMonitor';
import './general/DropDown';
import './general/Newsfeed';
import './general/MediumEditor';
import './course/slideview/SlideView';
import './course/slideview/SequenceScrollMonitor';
import './processplan/ProcessPlan';

// models
import './course/models/CourseModel';
import './course/models/UserModel';
import './course/models/UserCourseModel';
import './course/models/UserSequenceModel';
import './course/models/CustomUserSequenceModel';
import './course/models/PauseModel';
import './course/models/DaybreakModel';
import './course/models/UserFileModel';
import './course/models/CustomSequenceModel';
import './course/models/SlrgUserSequenceModel';
import './course/models/FeedbackSequenceModel';

import './templates/library';
import './templates/newsfeed';
import './templates/course-editor';
import './templates/processplan';
import './templates/slides';

import './general/TemplateContext';

export function init( setupObj:any ){
    
    setup.init( setupObj );

    backend.apiKey = 'api';
    backend.mapper.model( setup.data() );

    Lang.add( setup.data( 'lang' ) );

    scanner.scan( Node.body );
}
